import { getEndpointPlugin } from "@smithy/middleware-endpoint";
import { getSerdePlugin } from "@smithy/middleware-serde";
import { Command as $Command } from "@smithy/smithy-client";
import { commonParams } from "../endpoint/EndpointParameters";
import { ListChannelsAssociatedWithChannelFlowRequestFilterSensitiveLog, ListChannelsAssociatedWithChannelFlowResponseFilterSensitiveLog, } from "../models/models_0";
import { de_ListChannelsAssociatedWithChannelFlowCommand, se_ListChannelsAssociatedWithChannelFlowCommand, } from "../protocols/Aws_restJson1";
export { $Command };
export class ListChannelsAssociatedWithChannelFlowCommand extends $Command
    .classBuilder()
    .ep({
    ...commonParams,
})
    .m(function (Command, cs, config, o) {
    return [
        getSerdePlugin(config, this.serialize, this.deserialize),
        getEndpointPlugin(config, Command.getEndpointParameterInstructions()),
    ];
})
    .s("ChimeMessagingService", "ListChannelsAssociatedWithChannelFlow", {})
    .n("ChimeSDKMessagingClient", "ListChannelsAssociatedWithChannelFlowCommand")
    .f(ListChannelsAssociatedWithChannelFlowRequestFilterSensitiveLog, ListChannelsAssociatedWithChannelFlowResponseFilterSensitiveLog)
    .ser(se_ListChannelsAssociatedWithChannelFlowCommand)
    .de(de_ListChannelsAssociatedWithChannelFlowCommand)
    .build() {
}
